import Head from "next/head";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

const ContactUs = dynamic(() => import("../js/Components/Contact/ContactUs"));

//Dynamically load the home component and return it

const contactus = ({ data }) => {
    const {template_page_content} = useSelector((state) => state.globalReducer);
    
    return (
        <>
            <Head>
                <title>{template_page_content['contactus'].meta.meta_title}</title>
                
                <meta
                    name="description"
                    content={template_page_content['contactus'].meta.meta_description}
                />
            </Head>

        <ContactUs {...data} />
            
        </>
    );
};

export async function getStaticProps({ query, res }) {

    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}contact-us`);
        const data = await req.json();

        if(data.exception) {
            return {notFound: true}
        }
        
        return {
            props: {
                data
             },
        };
    } catch (error) {
        res.statusCode = 404;
        return {
            props: {}
        }
    }

}

export default contactus;
